import PelletGrillIcon from '@repo/ui/src/components/Icons/PelletGrillIcon';
import KettleGrillIcon from '@repo/ui/src/components/Icons/KettleGrillIcon';
import GasGrillIcon from '@repo/ui/src/components/Icons/GasGrillIcon';
import SousVideIcon from '@repo/ui/src/components/Icons/SousVideIcon';
import KamadoGrillIcon from '@repo/ui/src/components/Icons/KamadoGrillIcon';
import RotisserieIcon from '@repo/ui/src/components/Icons/RotisserieIcon';
import InductionIcon from '@repo/ui/src/components/Icons/InductionIcon';
import OvenIcon from '@repo/ui/src/components/Icons/OvenIcon';
import GriddleIcon from '@repo/ui/src/components/Icons/GriddleIcon';
import SteamerIcon from '@repo/ui/src/components/Icons/SteamerIcon';
import DeepFryerIcon from '@repo/ui/src/components/Icons/DeepFryerIcon';
import AirFryerIcon from '@repo/ui/src/components/Icons/AirFryerIcon';

export type IconId =
  | 'pelletGrill'
  | 'kettleGrill'
  | 'gasGrill'
  | 'sousVide'
  | 'kamadoGrill'
  | 'rotisserie'
  | 'induction'
  | 'oven'
  | 'griddle'
  | 'steamer'
  | 'deepFryer'
  | 'airFryer';

export interface IconItemProps {
  iconKey: IconId;
  label: string;
}

const iconMapping: Record<IconId, React.ComponentType> = {
  pelletGrill: PelletGrillIcon,
  kettleGrill: KettleGrillIcon,
  gasGrill: GasGrillIcon,
  sousVide: SousVideIcon,
  kamadoGrill: KamadoGrillIcon,
  rotisserie: RotisserieIcon,
  induction: InductionIcon,
  oven: OvenIcon,
  griddle: GriddleIcon,
  steamer: SteamerIcon,
  deepFryer: DeepFryerIcon,
  airFryer: AirFryerIcon,
};

const IconItem = ({ iconKey, label }: IconItemProps) => {
  const IconComponent = iconMapping[iconKey];

  return (
    <div className="flex flex-col gap-3 items-center">
      <div className="w-16 h-16 flex items-center justify-center">
        {IconComponent && <IconComponent />}
      </div>
      <p className="text-sm text-neutral-900 leading-5 text-center">{label}</p>
    </div>
  );
};

export default IconItem;
